// extracted by mini-css-extract-plugin
module.exports = {"langWrap":"locale-select_langWrap_l1WTe"};